// extracted by mini-css-extract-plugin
export var wrapper = "style-module--wrapper--IX2EM";
export var textContainer = "style-module--textContainer--bejY4";
export var stepsContainer = "style-module--stepsContainer--ZLB1J";
export var stepNb = "style-module--stepNb--6RZUW";
export var title = "style-module--title--7E89T";
export var step = "style-module--step---nbj3";
export var biggerMargin = "style-module--biggerMargin--e3-5b";
export var marginTop = "style-module--marginTop--mrFvw";
export var iconContainer = "style-module--iconContainer--oLfsr";